<template>
    <div class="feature-tour-slide">
        <h1 class="secondary-title">
            {{ title }}
        </h1>

        <p v-if="description">
            {{ description }}
        </p>

        <div class="image-wrapper">
            <img :src="image" />

            <div class="guide-wrapper" :style="{ ...guideLocation }">
                <ds-guide
                    v-if="showGuide"
                    :position="guidePosition"
                    show
                    :body-text="guideText"
                    :confirm-text="confirmText"
                    @confirm="next"
                >
                    <div slot="reference" class="guide-reference" />
                </ds-guide>
            </div>
        </div>
    </div>
</template>

<script>
export const POPOVER_POSITIONS = ['top', 'right', 'bottom', 'left', 'top-start', 'top-end', 'right-start', 'right-end', 'bottom-start', 'bottom-end', 'left-start', 'left-end'];

export default {
    props: {
        finalSlide: {
            type: Boolean,
            required: true,
        },
        guideLocation: {
            type: Object,
            default: () => ({
                top: 0,
                left: 0,
            }),
        },
        guidePosition: {
            type: String,
            default: 'top',
            validator: (item) => POPOVER_POSITIONS.includes(item),
        },
        guideText: String,
        image: String,
        loadDelay: {
            type: Number,
            default: 200,
        },
        title: String,
        description: String,
    },

    data() {
        return {
            showGuide: false,
        };
    },

    mounted() {
        this.load();
    },

    computed: {
        confirmText() {
            return this.finalSlide ? 'Finish tour' : 'Next';
        },
    },

    methods: {
        async load() {
            await new Promise((resolve) => setTimeout(resolve, this.loadDelay));

            this.showGuide = true;
        },

        async next() {
            this.showGuide = false;

            await this.$nextTick();

            this.$emit('next');
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .feature-tour-slide {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 $spacing-200;
    }

    .image-wrapper {
        margin-top: $spacing-200;
        position: relative;
    }

    .guide-wrapper {
        @include text-align-start;
        position: absolute;
    }

    h1 {
        font-family: $font-family-secondary-title;
        font-weight: $font-weight-bold;
        font-size: $font-size-mega;
    }

    p {
        font-size: $font-size-md;
        max-width: px-to-rem(500px);
        margin: $spacing-200 auto 0 auto;
        line-height: 1.5;
        padding-bottom: $spacing-100;
    }
</style>
